import { useEffect } from "react";
import { createPortal } from "react-dom";
import modalImageOne from "./../assets/modal-image-one.png";
import modalImageTryOn from "./../assets/modal-image-try-on.png";
import modalImageTryOnTwo from "./../assets/modal-image-try-on-two.png";
import modalImageTwo from "./../assets/modal-image-two.jpg";
import modalImageAiOne from "./../assets/modal-image-ai-one.png";
import modalImageAiTwo from "./../assets/modal-image-ai-two.png";
import modalImageAiThree from "./../assets/modal-image-ai-three.png";
import modalImageAiFour from "./../assets/modal-image-ai-four.png";
import { ReactComponent as ModalLogo } from "./../assets/svgs/modal-logo.svg";
import { ReactComponent as UnlockProIcon } from "./../assets/svgs/unlock-pro-icon.svg";

const MarketplaceWelcomeModal = ({
  isOpen,
  isAuthenticated,
  onClose,
  onUnlockPro,
  onSignIn,
}) => {
  const token = localStorage.getItem("authToken");
  const isSignedIn = Boolean(token) || Boolean(isAuthenticated);
  useEffect(() => {
    if (!isOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);
  if (!isOpen || typeof document === "undefined") return null;

  return createPortal(
  <div className="fixed inset-0 z-[2147483646] flex items-center justify-center bg-black/45 px-4 py-6">
      <div className="relative max-h-[92vh] w-full max-w-[1020px] overflow-y-auto rounded-[18px] bg-white shadow-2xl">
        <button
          type="button"
          aria-label="Close welcome modal"
          onClick={onClose}
          className="absolute right-4 top-2 z-20 flex h-8 w-8 items-center justify-center rounded-full bg-white text-[20px] leading-none text-[#4A4A4A] shadow-sm transition hover:bg-[#F4F4F4]"
        >
          ×
        </button>

        <div className="px-5 py-5 sm:px-8 md:px-10">
          <div className="flex max-h-[62px] items-center justify-between gap-4 rounded-[5px] border border-[#E5E5E5] py-[5px] pl-[5px] pr-[10px]">
            <div className="flex h-[52px] w-[50px] items-center justify-center gap-4 rounded-[5px] bg-gradient-to-b from-[#D9B7B8] to-[#AB4A4F] font-serif text-[20px] italic text-white shadow-sm">
              <ModalLogo />
            </div>

           {isSignedIn ? (
            <p className="pr-2 font-inter text-[12px] font-medium text-[#1F1F24]">
              Welcome to Eveness
            </p>
          ) : (
            <p className="pr-8 font-inter text-[12px] font-normal text-[#636363]">
              Already have an account?{" "}
              <button
                type="button"
                onClick={onSignIn}
                className="font-medium text-[#1F1F24] underline-offset-2 hover:underline"
              >
                Sign in
              </button>
            </p>
          )}
          </div>

          <div className="mt-5 text-center">
            <h2 className="font-inter text-[18.62px] font-normal leading-tight text-[#0A0A0A] sm:text-[22.62px] md:text-[26.62px]">
              Stop <span className="italic text-[#D1704F]">buying pieces</span>{" "}
              that don’t work on you.
            </h2>

            <p className="mt-2 font-inter text-[13px] font-normal text-[#4A5565] sm:text-[16px]">
              Personalized outfits &amp; color recommendations for your body.
            </p>
          </div>

          <div className="-mx-5 mt-5 overflow-x-auto px-5 pb-2 sm:-mx-8 sm:px-8 md:mx-auto md:w-full md:max-w-[900px] md:overflow-visible md:px-0 md:pb-0">
            <div className="flex w-max gap-[12px] md:grid md:w-full md:grid-cols-[1fr_0.98fr_1fr]">
              {/* Left try-on card */}
              <div className="w-[290px] shrink-0 overflow-hidden rounded-[5px] sm:w-[300px] md:w-auto">
              <div>
                <div className="relative h-[342px] md:h-[342px] bg-[#F6F6F6]">
                  <img
                    src={modalImageOne}
                    alt="Virtual try-on preview"
                    className="h-full w-full rounded-[7px] object-cover object-top"
                  />

                  <div className="absolute bottom-[10px] left-[10px] flex flex-col items-end gap-[8px]">
                    <div className="flex h-[30px] min-w-[110px] items-center rounded-[5px] bg-white px-[10px] shadow-sm">
                      <p className="font-inter text-[11px] font-normal leading-none text-[#333333]">
                        AI Try-on before you buy
                      </p>
                    </div>

                    <div className="flex flex-row gap-2">
                      <div className="mr-[18px] h-[62px] w-[62px] overflow-hidden rounded-[5px] bg-white shadow-sm">
                        <img
                          src={modalImageTryOn}
                          alt="Dress preview"
                          className="h-full w-full object-cover object-top"
                        />
                      </div>

                      <div className="h-[62px] w-[62px] overflow-hidden rounded-[5px] bg-white shadow-sm">
                        <img
                          src={modalImageTryOnTwo}
                          alt="User preview"
                          className="h-full w-full object-cover object-top"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>

              {/* Middle match card */}
              <div className="w-[290px] shrink-0 overflow-hidden rounded-[5px] bg-[#EFE7E2] p-[8px] sm:w-[300px] md:w-auto">
                <div className="relative h-[314px] overflow-hidden rounded-[3px] border-[3px] border-b-[15px] border-white bg-[#E9E2DC] p-0 md:h-[314px]">
                  <img
                    src={modalImageTwo}
                    alt="Personalized match preview"
                    className="h-full w-full object-cover object-top"
                  />

                  <div className="absolute bottom-[70px] left-1/2 z-10 flex h-[28px] w-[126px] -translate-x-1/2 items-center justify-center rounded-[4px] bg-white shadow-sm">
                    <span className="font-inter text-[11px] font-normal text-[#5CB7A3]">
                      95% match for you
                    </span>
                  </div>

                  <div className="absolute bottom-[6px] left-[9px] right-[9px] rounded-[7px] bg-white shadow-sm">
                    <div className="grid grid-cols-3 divide-x divide-[#ECECEC]">
                      {[
                        ["Fit", "95"],
                        ["Color", "93"],
                        ["Silhouette", "96"],
                      ].map(([label, value]) => (
                        <div
                          key={label}
                          className="flex h-[58px] flex-col items-center justify-center"
                        >
                          <span className="font-inter text-[9px] font-normal text-[#111111]">
                            {label}
                          </span>

                          <span className="mt-[5px] flex h-[25px] w-[25px] items-center justify-center rounded-full border-[2px] border-[#12B88C] bg-[#EFFFF9] font-inter text-[9px] font-semibold text-[#009B72]">
                            {value}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="relative">
                  <div className="absolute bottom-[2px] left-[2px] right-[4px] flex items-center justify-between font-inter text-[8px] font-semibold text-[#111111]">
                    <span>Reformation</span>
                    <span>$250</span>
                  </div>
                </div>
              </div>

              {/* Right AI shopping card */}
              <div className="w-[290px] shrink-0 overflow-hidden rounded-[5px] bg-[#EFEDEA] p-[6px] sm:w-[300px] md:w-auto">
                <div className="relative h-[318px] md:h-[330px]">
                  <div className="grid h-full grid-cols-2 gap-[5px]">
                    {[
                      modalImageAiOne,
                      modalImageAiTwo,
                      modalImageAiThree,
                      modalImageAiFour,
                    ].map((imageUrl, index) => (
                      <div
                        key={imageUrl}
                        className="relative overflow-hidden rounded-[2px] bg-white"
                      >
                        <img
                          src={imageUrl}
                          alt={`Shopping preview ${index + 1}`}
                          className="h-full w-full object-cover object-top"
                        />
                      </div>
                    ))}
                  </div>

                  <div className="absolute bottom-[54px] left-1/2 z-20 flex h-[32px] -translate-x-1/2 items-center whitespace-nowrap rounded-[3px] bg-white px-[12px] font-inter text-[9px] font-normal text-[#4A4A4A] shadow-sm">
                    Shop from 100k+ Pieces with AI
                  </div>

                  <div className="absolute bottom-[10px] left-[10px] right-[10px] z-10 flex h-[38px] items-center gap-[8px] rounded-[4px] bg-[#252525] p-[5px] shadow-lg">
                    <span className="min-w-0 flex-1 truncate pl-[9px] font-inter text-[10px] font-medium text-[#989898]">
                      Find me a dress for an afternoon out
                    </span>

                    <button
                      type="button"
                      className="h-[28px] rounded-[4px] bg-[#B7757C] px-[14px] font-inter text-[9px] font-semibold text-white"
                    >
                      Ask
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-[12px] gap-y-2 font-inter text-[14px] font-medium text-[#9F9FA9]">
            <span>Unlimited try-ons</span>
            <span className="hidden h-1 w-1 rounded-full bg-[#C8C8C8] sm:inline-block" />
            <span>Personalized matches</span>
            <span className="hidden h-1 w-1 rounded-full bg-[#C8C8C8] sm:inline-block" />
            <span>Cancel anytime</span>
          </div>

          <div className="mx-auto mt-4 max-w-[360px]">
            <button
              type="button"
              onClick={onUnlockPro}
              className="flex h-10 w-full items-center justify-center gap-2 rounded-[8px] bg-[#252525] p-[10px] font-inter text-[13px] font-medium text-white transition hover:bg-black"
            >
              <span aria-hidden="true">
                <UnlockProIcon />
              </span>
              <span className="text-[14px] font-light">Unlock Pro</span>
              <span className="text-[14px] font-normal">— $4.99/mo</span>
            </button>

            <button
              type="button"
              onClick={onClose}
              className="mt-[10px] w-full text-center font-inter text-[10px] font-normal text-[#99A1AF] transition hover:text-[#55555C]"
            >
              Continue with free version
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default MarketplaceWelcomeModal;
